import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { ROLE_PART_MANAGER } from '../../../../redux/constants/rolesConstants';
import {
  commentLimitValidation,
  notBlankValidation,
  partCountValidation,
  priceValidation,
} from '../../../../utils/validations';
import Input from '../../../shared/input/Input';
import Price from '../../../shared/price/Price';
import PartSelect from '../../../shared/select/part/PartSelect';
import FormToggle from '../../../shared/toggle/FormToggle';
import Toggle from '../../../shared/toggle/Toggle';

const VisitPartForm = ({ onSubmit, part, readOnly, loading }) => {
  const methods = useForm({ defaultValues: part });
  const partPrice = methods.watch('partPrice') || 0;
  const count = methods.watch('count') || 0;
  const [isCreateNew, setIsCreateNew] = useState(false);
  const canCreatePart = useSelector((state) => state.auth?.userData?.roles.includes(ROLE_PART_MANAGER));

  const toggleMode = () => {
    if (isCreateNew) {
      methods.setValue('partName', '');
      methods.clearErrors('partName');
      methods.setValue('part', part?.part || null);
    } else {
      methods.setValue('part', null);
      methods.clearErrors('part');
    }
    setIsCreateNew(!isCreateNew);
  };

  return (
    <FormProvider {...methods}>
      <form
        id="visitPart-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => onSubmit(data))}
      >
        <div className="flex items-start gap-3">
          <div className="flex-1">
            {isCreateNew ? (
              <Input
                label="Назва нової деталі"
                name="partName"
                disabled={readOnly || loading}
                placeholder={'Введіть назву деталі'}
                validation={notBlankValidation}
                autoFocus
              />
            ) : (
              <PartSelect disabled={loading || readOnly} autoFocus="true" />
            )}
          </div>
          {!readOnly && canCreatePart && (
            <div className="mt-6 md:mt-9">
              <Toggle isActive={isCreateNew} disabled={loading} onChange={toggleMode} label="Нова" />
            </div>
          )}
        </div>
        <Input
          label="Ціна деталі"
          type="number"
          name="partPrice"
          disabled={readOnly || loading}
          placeholder={'Введіть ціну деталі'}
          validation={priceValidation}
        />
        <Input
          label="Кількість"
          type="number"
          name="count"
          disabled={readOnly || loading}
          placeholder={'Введіть кількість'}
          validation={partCountValidation}
        />
        <Input
          label="Коментар"
          multiline
          name="comment"
          disabled={readOnly || loading}
          placeholder={'Введіть коментар'}
          validation={commentLimitValidation}
        />
        <FormToggle name="isCritical" label="Критична деталь" disabled={readOnly || loading} />
        <Price price={partPrice * count} />
      </form>
    </FormProvider>
  );
};

export default VisitPartForm;
